<b3-modal
  [open]="open"
  overlay
  size="lg"
  (b3-close)="onModalDismiss()">
  <b3-modal-header
    [heading]="viewModel.title"
    aria-level="2"
    icon="check_circle"
    icon-tone="success"
    close-aria-label="Fechar">
  </b3-modal-header>

  <b3-modal-body>
    <div class="credit-register-success-modal">
      <p class="credit-register-success-modal__description">{{ viewModel.description }}</p>

      <div class="credit-register-success-modal__next-steps" *ngIf="viewModel.showNextSteps">
        <div class="credit-register-success-modal__next-steps-row">
          <b3-icon name="event" class="credit-register-success-modal__next-steps-icon"></b3-icon>
          <div class="credit-register-success-modal__next-steps-content">
            <p class="credit-register-success-modal__next-steps-title">Próximos passos</p>
            <p class="credit-register-success-modal__next-steps-text">
              Aguarde a Confirmação de Registro e o aceite da Operação.
            </p>
          </div>
        </div>
      </div>

      <div class="credit-register-success-modal__details">
        <p class="credit-register-success-modal__details-title">Detalhes do registro</p>
        <div class="credit-register-success-modal__details-list">
          <div class="credit-register-success-modal__detail-row">
            <span class="credit-register-success-modal__detail-label">Código IF</span>
            <span class="credit-register-success-modal__detail-value">{{ viewModel.carbonCreditCode }}</span>
          </div>
          <div class="credit-register-success-modal__detail-row">
            <span class="credit-register-success-modal__detail-label">Data do envio</span>
            <span class="credit-register-success-modal__detail-value">{{ viewModel.sentDateLabel }}</span>
          </div>
          <div class="credit-register-success-modal__detail-row">
            <span class="credit-register-success-modal__detail-label">Status</span>
            <span class="credit-register-success-modal__status-badge">
              <b3-icon name="sync" class="credit-register-success-modal__status-icon"></b3-icon>
              <span class="credit-register-success-modal__status-text">{{ viewModel.statusLabel }}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </b3-modal-body>

  <b3-modal-footer>
    <div class="credit-register-success-modal__footer">
      <b3-button
        type="button"
        variant="outlined"
        tone="default"
        (b3-click)="onNewRegister()">
        Novo registro
      </b3-button>
      <b3-button
        type="button"
        variant="filled"
        tone="default"
        (b3-click)="onConsultRegister()">
        Consultar registro
      </b3-button>
    </div>
  </b3-modal-footer>
</b3-modal>
